import React from 'react'
import cx from 'classnames'
import WhiteLogo from '/img/svg/logo-white'
import FacebookLogo from '/img/svg/facebook'
import TwitterLogo from '/img/svg/twitter'
import LinkedInLogo from '/img/svg/linked-in'
import InstagramLogo from '/img/svg/instagram'
import YouTubeLogo from '/img/svg/you-tube'
import EnvelopeIcon from '/img/svg/envelope'

class Footer extends React.Component {
  renderLinks() {
    const { links } = this.props.footer

    return links.map((link, index) => (
      <a
        key={link.url}
        href={link.url}
        className={cx('hover:underline focus:underline', {
          'pr-15': index === 0,
          'px-15': index === links.length - 1,
          'border-l border-white': index != 0
        })}
        target="_blank"
        rel="noopener"
      >
        {link.title}
      </a>
    ))
  }

  renderSocialMedia() {
    const { social } = this.props

    return social.map((link, index) => (
      <li key={`footer-${link.url}`}>
        <a
          href={link.url}
          target="_blank"
          rel="noopener"
          className="block hover:-translate-y-3 transition-fast"
        >
          <span className="screenreader">{link.title}</span>
          {link.title === 'Facebook' && <FacebookLogo />}
          {link.title === 'Twitter' && <TwitterLogo />}
          {link.title === 'LinkedIn' && <LinkedInLogo />}
          {link.title === 'Instagram' && <InstagramLogo />}
          {link.title === 'YouTube' && <YouTubeLogo />}
          {link.title === 'Contact Us' && (
            <EnvelopeIcon className="w-35 h-35" />
          )}
        </a>
      </li>
    ))
  }

  render() {
    const { theme, footer } = this.props

    return (
      <footer className={`relative pb-90 pt-30 xl:pt-55 ${theme.bgColor}`}>
        <div className="container px-20 flex flex-col md:flex-row items-center xl:items-start text-white justify-between text-center md:text-left">
          <a href="https://danaher.com">
            <WhiteLogo className="w-170 flex-shrink-0 mb-25" />
          </a>
          <div>
            <p className="mb-10 max-w-545">{footer.copyright}</p>
            <p>{this.renderLinks()}</p>
          </div>
          <ul className="flex">{this.renderSocialMedia()}</ul>
        </div>
      </footer>
    )
  }
}

export default Footer
